import { render, staticRenderFns } from "./VideoButton.vue?vue&type=template&id=626c0172&scoped=true&"
import script from "./VideoButton.vue?vue&type=script&lang=ts&"
export * from "./VideoButton.vue?vue&type=script&lang=ts&"
import style0 from "./VideoButton.vue?vue&type=style&index=0&id=626c0172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c0172",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsPlayIcon24px: require('/var/www/packages/theme/components/icons/play/PlayIcon24px.vue').default})
